import type { Translations } from '../../../types'

const shopVariantModalMessages: Translations = {
  "shop.variantModal.eyebrow": "Varianti prodotto",
  "shop.variantModal.titleEdit": "Modifica variante",
  "shop.variantModal.titleCreate": "Crea nuova variante",
  "shop.variantModal.subtitle": "Inserisci i dettagli principali della variante e scegli dove mostrarla.",
  "shop.variantModal.sections.identity": "Dettagli principali",
  "shop.variantModal.sections.identityHint": "Nome, descrizione, prezzo e quantita della variante.",
  "shop.variantModal.sections.attributes": "Attributi variante",
  "shop.variantModal.sections.attributesHint": "Campi che identificano questa variante nel tipo prodotto.",
  "shop.variantModal.sections.overrides": "Override",
  "shop.variantModal.sections.overridesHint": "Campi che possono ereditare dal prodotto padre o essere sovrascritti qui.",
  "shop.variantModal.sections.metadata": "Informazioni aggiuntive",
  "shop.variantModal.sections.metadataHint": "Campi opzionali chiave/valore utili per filtri o integrazioni.",
  "shop.variantModal.sections.assets": "Immagine variante",
  "shop.variantModal.sections.assetsHint": "Carica un'immagine con drag and drop o selezionala dalla Media Library.",
  "shop.variantModal.fields.name": "Nome variante *",
  "shop.variantModal.fields.namePlaceholder": "Es. Blu - taglia 42",
  "shop.variantModal.fields.description": "Descrizione",
  "shop.variantModal.fields.descriptionPlaceholder": "Dettagli utili per distinguere questa variante",
  "shop.variantModal.fields.price": "Prezzo *",
  "shop.variantModal.fields.pricePlaceholder": "Es. 79.90",
  "shop.variantModal.fields.quantity": "Quantita *",
  "shop.variantModal.fields.quantityPlaceholder": "Es. 12",
  "shop.variantModal.fields.inheritedValue": "Valore ereditato",
  "shop.variantModal.fields.currentOverride": "Override corrente",
  "shop.variantModal.fields.overrideStateInherited": "Ereditato",
  "shop.variantModal.fields.overrideStateOverridden": "Sovrascritto",
  "shop.variantModal.fields.metadataKey": "Chiave",
  "shop.variantModal.fields.metadataValue": "Valore",
  "shop.variantModal.fields.imagePreviewAlt": "Immagine variante",
  "shop.variantModal.dropzone.empty": "Trascina una foto variante qui oppure usa i pulsanti sotto.",
  "shop.variantModal.dropzone.helper": "La foto selezionata viene usata come immagine principale della variante.",
  "shop.variantModal.errors.invalidImageFile": "Carica un file immagine valido per la variante.",
  "shop.variantModal.errors.uploadFailed": "Upload immagine variante fallito",
  "shop.variantModal.errors.requiredFields": "Compila tutti i campi variante richiesti",
  "shop.variantModal.messages.imageUploaded": "Foto variante caricata",
  "shop.variantModal.mediaLibrary.description": "Seleziona un elemento per impostarlo come immagine principale della variante.",
  "shop.variantModal.actions.addMetadata": "+ Aggiungi",
  "shop.variantModal.actions.removeMetadata": "Rimuovi",
  "shop.variantModal.actions.resetToInherit": "Ripristina ereditarieta",
  "shop.variantModal.actions.uploadImage": "Carica foto",
  "shop.variantModal.actions.uploadingImage": "Upload...",
  "shop.variantModal.actions.chooseFromMediaLibrary": "Scegli da Media Library",
  "shop.variantModal.actions.clearImage": "Rimuovi foto",
  "shop.variantModal.actions.save": "Salva variante",
}

export default shopVariantModalMessages
